import React, { useState } from 'react'
import { Grid, Typography, Divider, Paper, Box, Collapse } from '@mui/material'
import Chart from 'chart.js/auto'  //idk what this does, i don't even use it... but remove it and everything breaks
import { Doughnut } from 'react-chartjs-2';
import CircleIcon from '@mui/icons-material/Circle';
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import RYGGLegend from '../adminreport/RYGGLegend';
/** 
 * 
 * This component is expecting the following input. 

{
    "Order": "30",
    "ComponentType": "KEY VALUE EXPANDED NESTED",
    "Visible": "1",
    "Label": "",
    "Sections": [
        {
            "Order": "10",
            "Visible": "1",
            "Label": "Stress",
            "HelpText": "",
            "Values": [
                {
                    "Order": "10",
                    "Label": "No Interest",
                    "Distribution": "0"
                },
                {
                    "Order": "20",
                    "Label": "Not Now",
                    "Distribution": "0"
                },
                {
                    "Order": "30",
                    "Label": "Ready",
                    "Distribution": "0"
                },
                {
                    "Order": "40",
                    "Label": "Recent Change",
                    "Distribution": "0"
                },
                {
                    "Order": "50",
                    "Label": "Longer Change",
                    "Distribution": "0"
                }
            ]
        }
    ]
}
*/
const colors = ['#E6323A', '#FE9350', '#FEC957', '#6CDE6C', '#209D70']

const DonutSection = (props) => {


    const OrderedSections = [...props.component.Sections].sort((a, b) => {
        const aValues = a.Values
        const bValues = b.Values
        // b - a for descending, aka.. most ready is first.
        return parseInt(bValues[2].Distribution) - parseInt(aValues[2].Distribution)
    })


    //const FilteredSections = OrderedSections.filter((a)=> { return a.Visible==='1' })

    const [expandSection, setExpandSection] = useState(false)
    const DisplayItem = ({ displayValues }) => {


        const returnme = displayValues.Values.map((x, i) => {
            return (
                <Grid item xs={12}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={7}><Typography variant="caption" align="right">{x.Label}:</Typography></Grid>
                        <Grid item xs={3}><Typography variant="caption" align="left" fontWeight="bold">{Math.floor(parseInt(x.Distribution || x.Value,0))}%</Typography></Grid>
                        <Grid item xs={2}><CircleIcon fontSize='small' sx={{ color: colors[i] }} /></Grid>
                    </Grid>
                </Grid>
            )
        })

        return returnme

    }

    const DisplaySection = ({ displayValues, defaultCollapse }) => {
        const labelCenter = {
            id: "labelCenter",
            beforeDraw: function (chart) {
                var width = chart.width,
                    height = chart.height,
                    ctx = chart.ctx;
                ctx.restore();
                var fontSize = (height / 160).toFixed(2);
                ctx.font = fontSize + "em sans-serif";
                ctx.textBaseline = "top";
                var text = displayValues.Label,
                    textX = Math.round((width - ctx.measureText(text).width) / 2),
                    textY = height / 2;
                ctx.fillText(text, textX, textY);
                ctx.save();
            }
        };
        const plugins = [labelCenter]


        const [isExpanded, setIsExpanded] = useState(defaultCollapse)
        //const colors = props.component.Values.map((x)=>{return x.Color})
        const values = displayValues.Values.map((x) => { return parseInt(x.Distribution || x.Value, 0) })
        const labels = displayValues.Values.map((x) => { return parseInt(x.Label, 0) + "%" })
        const data = {
            datasets: [
                {

                    label: labels,
                    data: values,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 0,
                }
            ]
        }
        const motionVariants = {
            hidden: { opacity: 0, x: 0, y: 0 },
            show: {
                opacity: 1, x: 0, y: 0,
                transition: {
                    delay: 0.1,
                    duration: 0.5,
                }
            }
        }
        const options = {
            responsive: true,
            cutout: '80%',
            animation: {
                animateRotate: true,
                render: false,
            },
            tooltips: {
                enabled: true
            },
            plugins: {

                legend: {
                    display: false
                }
            }
        }
        return (

            <motion.div variants={motionVariants} initial="hidden" animate="show" whileHover={{ scale: 1.5 }} style={{ height: '100%' }}>
                <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }} onClick={() => setIsExpanded(!isExpanded)}>
                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                        <Grid item xs={12} md={12} m={isExpanded ? 0 : -2}>
                            <Box sx={{ maxWidth: "200px", alignItems: "center", justifyContent: "center" }}>
                                <Doughnut data={data} options={options} plugins={plugins} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={12} m={isExpanded ? 0 : -2}>
                            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                <Grid container direction="row" >
                                    <DisplayItem displayValues={displayValues} />
                                </Grid>
                            </Collapse>
                        </Grid>

                    </Grid>
                </Paper>
            </motion.div>
        )
    }


    const FiveColorArray = [
        { Label: "No Interest", Color: '#E6323A' }
        , { Label: "Not Now", Color: '#FE9350' }
        , { Label: "Ready", Color: '#FEC957' }
        , { Label: "Recent Change", Color: '#6CDE6C' }
        , { Label: "Longer Change", Color: '#209D70' }
    ]





    return (
        <Grid item lg={12} md={12} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>


            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h4" align="center">{props.component.Label}</Typography>
                </Grid>
                <Grid item xs={12} m={1}>
                    <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                </Grid>
                <Grid item xs={12} m={1}>
                    <RYGGLegend variant="FIVE COLOR" FiveColors={FiveColorArray} />
                </Grid>
                <Grid item xs={12}>
                    <Collapse in={true} timeout="auto" unmountOnExit>
                        <Grid container columns={30} direction="row" alignItems="center" justifyContent="center" spacing={2}>

                            {
                                OrderedSections && OrderedSections.map((displayValues, index) => {
                                    return (
                                        <Grid item xs={30} sm={15} md={6}>
                                            <DisplaySection displayValues={displayValues} key={index} defaultCollapse={false} />
                                        </Grid>
                                    )

                                })
                            }
                        </Grid>
                    </Collapse>
                </Grid>

            </Grid>

        </Grid>
    )
}

export default DonutSection